<template>
  <div>
    <v-dialog
      v-model="isOpened"
      persistent
      scrollable
      width="980px"
    >
      <v-card>
        <v-card-title>
          {{ title }}
          <v-spacer />
          <v-btn icon @click="closeDialog">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0" v-if="user">
          <v-row no-gutters justify="center" align="stretch">
            <div style="background-color: #ede7f6;">
              <v-tabs
                v-model="activeTab"
                background-color="deep-purple lighten-5"
                vertical
                slider-color="primary"
              >
                <v-tab v-for="tab in tabs" :key="tab.key">
                  {{ tab.label }}
                </v-tab>
              </v-tabs>
            </div>
            <v-col>
              <v-tabs-items v-model="activeTab">
                <v-tab-item :key="infosTabKey" class="pa-4" v-if="infosTabKey !== null">
                  <v-row no-gutters align="center" justify="center" class="mb-4">
                    <v-col>
                      <h3>Informations générales de l'utilisateur</h3>
                    </v-col>
                  </v-row>
                  <v-form @submit.prevent.native="$canWrite && (saveGlobalInformations())">
                    <v-alert
                      :value="true"
                      type="warning"
                      class="mb-4"
                      v-if="this.isMainAdminFlagUpdated"
                    >
                      Si vous modifiez le rôle de l'utilisateur, vérifiez l'onglet "Droits d'accès" par la suite.
                    </v-alert>
                    <v-row>
                      <v-col cols="12" md="6" class="pa-3">
                        <v-text-field v-model="user.firstname" label="Prénom" outlined hide-details required />
                      </v-col>
                      <v-col cols="12" md="6" class="pa-3">
                        <v-text-field v-model="user.lastname" label="Nom" outlined hide-details required />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6" class="pa-3">
                        <v-text-field v-model="user.email" label="Email" outlined hide-details required />
                      </v-col>
                      <v-col xs12 md6 v-if="isAggregator && user.Client_id === company.id">
                        <v-text-field v-model="user.username" label="Identifiant" outlined hide-details />
                      </v-col>
                      <v-col xs12 md6 v-else-if="user.Client_id !== company.id">
                        <v-select
                          v-model="user.role"
                          :items="clientUserRoles"
                          label="Rôle"
                          item-text="label"
                          item-value="id"
                          outlined
                          hide-details
                          cchange="clientUserRightChanged(user)"
                        ></v-select>
                      </v-col>
                      <v-col xs12 md6 v-else>
                        <v-select
                          v-model="user.role"
                          :items="roles"
                          label="Rôle"
                          item-text="label"
                          item-value="id"
                          outlined
                          hide-details
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row v-if="isAggregator && user.Client_id === company.id">
                      <v-col cols="12" md="6" class="pa-3">
                        <v-select
                          v-model="user.role"
                          :items="roles"
                          label="Rôle"
                          item-text="label"
                          item-value="id"
                          outlined
                          hide-details
                          @change="isMainAdminFlagUpdated = true;"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="pt-8">
                      <v-btn :disabled="!$canWrite" text @click="$canWrite && (isUserPasswordDialogOpened = true)">
                        <v-icon left color="black">lock_open</v-icon>
                        Changer le mot de passe
                      </v-btn>
                      <v-btn :disabled="!$canWrite" text @click="$canWrite && (isUserSendInvitationDialogOpened = true)" v-if="isIndeegoUser">
                        <v-icon left color="black">send</v-icon>
                        Renvoyer invitation
                      </v-btn>
                      <v-spacer />
                      <v-btn
                        :disabled="!$canWrite"
                        type="submit"
                        color="primary darken-1"
                        :loading="isSavingInformations"
                      >
                        Enregistrer
                      </v-btn>
                    </v-row>
                  </v-form>
                </v-tab-item>
                <v-tab-item :key="rightsTabKey" class="pa-4" v-if="rightsTabKey !== null">
                  <v-row no-gutters align="center" justify="center" class="mb-4">
                    <v-col>
                      <h3>Droits d'accès de l'utilisateur aux prestaires</h3>
                    </v-col>
                  </v-row>
                  <v-row no-gutters justify="center" v-if="isRightsLoading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                  <v-list v-else>
                    <template v-for="(userRight, index) in userRights">
                      <v-list-item :key="`right-${index}`">
                        <div>
                          <v-icon class="mr-2" color="error" v-if="userRight.right.id === 1">cancel</v-icon>
                          <v-icon class="mr-2" color="info" v-if="userRight.right.id === 2">visibility</v-icon>
                          <v-icon class="mr-2" color="success" v-if="userRight.right.id === 3">verified_user</v-icon>
                        </div>
                        <v-list-item-content>
                          <v-list-item-title>{{ userRight.maker.name }}</v-list-item-title>
                        </v-list-item-content>
                        <v-spacer></v-spacer>
                        <v-list-item-action class="ma-0">
                          <v-select
                            :items="rights"
                            v-model="userRight.right"
                            item-text="label"
                            item-value="id"
                            return-object
                            solo
                            text
                            flat
                            hide-details
                            small-chips
                            class="right-select"
                            @change="$canWrite && (rightChanged(userRight))"
                          ></v-select>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider v-if="index + 1 < userRights.length" :key="index" />
                    </template>
                  </v-list>
                  <v-row no-gutters class="pt-5">
                    <v-spacer />
                    <v-btn color="primary darken-1" class="mr-3" :disabled="!$canWrite || (!rightsToUpdate.length)" :loading="isSavingRights" @click="$canWrite && (saveRights())">Enregistrer</v-btn>
                  </v-row>
                </v-tab-item>
                <v-tab-item :key="notificationsTabKey" class="pa-4" v-if="notificationsTabKey !== null">
                  <v-row no-gutters justify="center" v-if="isNotificationRulesLoading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                  <template v-else>
                    <v-row no-gutters align="center" justify="center" class="mb-2">
                      <v-col>
                        <h2>Règles de notification des interventions</h2>
                      </v-col>
                      <v-tooltip left>
                        <template v-slot:activator="{ on }">
                          <v-btn :disabled="!$canWrite" fab small depressed color="primary darken-1" @click="$canWrite && (isNotificationRuleDialogOpened = true)" v-on="on">
                            <v-icon>add</v-icon>
                          </v-btn>
                        </template>
                        <div>Nouvelle règle</div>
                      </v-tooltip>
                    </v-row>
                    <h3>Être notifié quand</h3>
                    <v-list>
                      <template v-for="(notificationRule, index) in userNotificationRules">
                        <v-row no-gutters justify="center" align="center" class="notification-rule" :key="`rule${notificationRule.id}`">
                          <h4 class="mr-3">#{{ index + 1 }}</h4>
                          <v-col class="pb-2">
                            <v-row no-gutters justify="start" align="center">
                              <v-chip color="deep-purple" outlined small class="mt-2">
                                {{ getNotificationRuleTypeLabels(notificationRule.type) }}
                              </v-chip>
                              <v-chip color="#f40404" outlined small class="mt-2">
                                {{ getNotificationRuleOriginLabels(notificationRule.origin) }}
                              </v-chip>
                              <v-chip color="orange" outlined small class="mt-2" v-if="(client.isRoot || client.isSelfMaker) && notificationRule.isAssigned">
                                {{ `Si assigné` }}
                              </v-chip>
                              <v-chip
                                color="light-blue"
                                outlined
                                small
                                class="mt-2"
                                v-if="
                                  client.isRoot
                                  && company.id === user.Client_id
                                  && notificationRule.client
                                "
                              >
                                {{ notificationRule.client ? notificationRule.client.name : `Tous clients` }}
                              </v-chip>
                              <v-chip
                                color="light-blue"
                                outlined
                                small
                                class="mt-2"
                                v-if="
                                  !client.isRoot
                                  && notificationRule.maker
                                "
                              >
                                {{ notificationRule.maker ? notificationRule.maker.name : `Tous prestataires` }}
                              </v-chip>
                              <v-chip
                                color="#fa8f01"
                                outlined
                                small
                                class="mt-2"
                                v-if="
                                  !client.isRoot
                                  && notificationRule.site
                                "
                              >
                                {{ notificationRule.site ? notificationRule.site.name : `Tous sites` }}
                              </v-chip>
                              <v-chip color="green darken-2" outlined small class="mt-2" v-if="notificationRule.domain">
                                {{ notificationRule.domain ? notificationRule.domain.name : `Tous domaines` }}
                              </v-chip>
                              <v-chip color="pink" outlined small class="mt-2" v-if="notificationRule.priority">
                                {{ notificationRule.priority ? notificationRule.priority.name : `Toutes priorités` }}
                              </v-chip>
                            </v-row>
                          </v-col>
                          <v-btn :disabled="!$canWrite" icon text color="red" class="mx-0 my-1" @click="$canWrite && (openConfirmRemoveRule(notificationRule))">
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-row>
                        <v-divider :key="`divider${index}`" v-if="index < userNotificationRules.length -1"></v-divider>
                      </template>
                      <template v-if="!userNotificationRules.length">
                        <v-row no-gutters justify="center" align="center">
                          <v-icon color="primary darken-1" class="mr-2" style="font-size: 2rem;">drafts</v-icon>
                          <h3 class="grey--text text--darken-2" style="font-weight: 500;">Aucune règle dans cette catégorie</h3>
                        </v-row>
                      </template>
                    </v-list>
                    <div class="mt-5">
                      <h3>NE PAS être notifié quand</h3>
                    </div>
                    <v-alert
                      :value="true"
                      class="mt-2 mb-0"
                      type="info"
                    >
                      Ces règles sont prioritaires sur les autres
                    </v-alert>
                    <v-list class="mb-5">
                      <template v-for="(notificationRule, index) in userNegativeNotificationRules">
                        <v-row no-gutters justify="center" align="center" class="notification-rule" :key="`rule${notificationRule.id}`">
                          <h4 class="mr-3">#{{ index + 1 }}</h4>
                          <v-col class="pb-2">
                            <v-row no-gutters justify="start" align="center">
                              <v-chip color="deep-purple" outlined small class="mt-2">
                                {{ getNotificationRuleTypeLabels(notificationRule.type) }}
                              </v-chip>
                              <v-chip color="#f40404" outlined small class="mt-2">
                                {{ getNotificationRuleOriginLabels(notificationRule.origin) }}
                              </v-chip>
                              <v-chip color="orange" outlined small class="mt-2" v-if="(client.isRoot || client.isSelfMaker) && notificationRule.isAssigned">
                                {{ `Si assigné` }}
                              </v-chip>
                              <v-chip
                                color="light-blue"
                                outlined
                                small
                                class="mt-2"
                                v-if="
                                  client.isRoot
                                  && company.id === user.Client_id
                                  && notificationRule.client
                                "
                              >
                                {{ notificationRule.client ? notificationRule.client.name : `Tous clients` }}
                              </v-chip>
                              <v-chip
                                color="light-blue"
                                outlined
                                small
                                class="mt-2"
                                v-if="
                                  !client.isRoot
                                  && notificationRule.maker
                                "
                              >
                                {{ notificationRule.maker ? notificationRule.maker.name : `Tous prestataires` }}
                              </v-chip>
                              <v-chip
                                color="#fa8f01"
                                outlined
                                small
                                class="mt-2"
                                v-if="
                                  !client.isRoot
                                  && notificationRule.site
                                "
                              >
                                {{ notificationRule.site ? notificationRule.site.name : `Tous sites` }}
                              </v-chip>
                              <v-chip color="green darken-2" outlined small class="mt-2" v-if="notificationRule.domain">
                                {{ notificationRule.domain ? notificationRule.domain.name : `Tous domaines` }}
                              </v-chip>
                              <v-chip color="pink" outlined small class="mt-2" v-if="notificationRule.priority">
                                {{ notificationRule.priority ? notificationRule.priority.name : `Toutes priorités` }}
                              </v-chip>
                            </v-row>
                          </v-col>
                          <v-btn :disabled="!$canWrite" icon text color="red" class="mx-0 my-1" @click="$canWrite && (openConfirmRemoveRule(notificationRule))">
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-row>
                        <v-divider :key="`divider${index}`" v-if="index < userNegativeNotificationRules.length -1"></v-divider>
                      </template>
                      <template v-if="!userNegativeNotificationRules.length">
                        <v-row no-gutters justify="center" align="center">
                          <v-icon color="primary darken-1" class="mr-2" style="font-size: 2rem;">drafts</v-icon>
                          <h3 class="grey--text text--darken-2" style="font-weight: 500;">Aucune règle dans cette catégorie</h3>
                        </v-row>
                      </template>
                    </v-list>
                  </template>
                </v-tab-item>
                <v-tab-item :key="planningTabKey" class="pa-4" v-if="planningTabKey !== null">
                  <v-row no-gutters align="center" justify="center" class="mb-2">
                    <v-col>
                      <h3>Réglages du planning pour l'utilisateur</h3>
                    </v-col>
                  </v-row>
                  <v-row no-gutters justify="center" align="center" class="pt-4">
                    Cet utilisateur est-il inclus dans le planning de l'entreprise ?
                    <v-spacer />
                    <v-btn-toggle
                      v-model="user.isExcludedFromPlanning"
                      borderless
                      color="primary"
                    >
                      <v-btn class="px-4" :value="false">
                        Oui
                      </v-btn>
                      <v-btn class="px-4" :value="true">
                        Non
                      </v-btn>
                    </v-btn-toggle>
                  </v-row>
                  <v-row no-gutters class="pt-8">
                    <v-spacer />
                    <v-btn
                      :disabled="!$canWrite"
                      type="submit"
                      color="primary darken-1"
                      :loading="isSavingPlanning"
                      @click="$canWrite && (savePlanning())"
                    >
                      Enregistrer
                    </v-btn>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- <v-divider /> -->
        <v-card-actions class="py-3" v-if="false">
          <!-- <v-row no-gutters wrap v-if="$activeTab && $activeTab.key === 0">
            <v-btn :disabled="!$canWrite" text @click="$canWrite && (isUserPasswordDialogOpened = true)">
              <v-icon left color="black">lock_open</v-icon>
              Changer le mot de passe
            </v-btn>
            <v-btn :disabled="!$canWrite" text @click="$canWrite && (isUserSendInvitationDialogOpened = true)" v-if="isIndeegoUser">
              <v-icon left color="black">send</v-icon>
              Renvoyer invitation
            </v-btn>
            <v-spacer />
            <v-btn :disabled="!$canWrite" color="primary darken-1" class="mr-3" :loading="isSavingInformations" @click="$canWrite && (saveGlobalInformations())">Enregistrer</v-btn>
          </v-row> -->
          <v-row no-gutters wrap v-if="$activeTab && $activeTab.key === 1">
            <v-spacer />
            <v-btn color="primary darken-1" class="mr-3" :disabled="!$canWrite || (!rightsToUpdate.length)" :loading="isSavingRights" @click="$canWrite && (saveRights())">Enregistrer</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notification-rule-dialog v-model="isNotificationRuleDialogOpened" :rule="updatingNotificationRule" :client="client"></notification-rule-dialog>
    <confirm-dialog v-model="isUserSendInvitationDialogOpened" @yes="resendInvitation()" v-if="isIndeegoUser" />
    <confirm-dialog v-model="isNotificationRuleRemoveDialogOpened" @yes="removeNotificationRule()"></confirm-dialog>
    <user-password-dialog v-model="isUserPasswordDialogOpened"></user-password-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import _ from 'lodash';
import NotificationRuleDialog from '@/components/NotificationRuleDialog.vue';
import UserPasswordDialog from '@/components/UserPasswordDialog.vue';

export default {
  name: `UserModal`,
  props: [`value`, `client`],
  data: () => ({
    isRightsLoading: false,
    isNotificationRulesLoading: false,
    activeTab: 0,
    isMainAdminFlagUpdated: false,
    isSavingInformations: false,
    isSavingRights: false,
    isSavingPlanning: false,
    isNotificationRuleDialogOpened: false,
    isNotificationRuleRemoveDialogOpened: false,
    isUserPasswordDialogOpened: false,
    isUserSendInvitationDialogOpened: false,
    notificationRuleToBeRemoved: null,
    updatingNotificationRule: null,
    rights: [
      { id: 1, label: `Interdit` },
      { id: 2, label: `Lecteur` },
      { id: 3, label: `Contributeur` },
    ],
    userRightsOrigin: [],
    rightsToUpdate: [],
    roles: [
      { id: `administrator`, label: `Administrateur` },
      { id: `contributor`, label: `Contributeur` },
      { id: `reader`, label: `Lecteur` },
    ],
    clientUserRoles: [
      { id: `contributor`, label: `Contributeur` },
      { id: `reader`, label: `Lecteur` },
    ],
    clientUserRights: [
      { id: 1, label: `Gestion` },
      { id: 2, label: `Consultation` },
    ],
    clientAdminList: [
      { name: `Gestion`, value: true },
      { name: `Consultation`, value: false },
    ],
    user: null,
  }),
  computed: {
    ...mapState(`model/client`, [
      `company`,
      `isAggregator`,
      `isMaker`,
      `isSelfMaker`,
    ]),
    ...mapGetters(`model/user`, [
      `isIndeegoUser`,
    ]),
    ...mapState(`model/user`, {
      storeUser: `currentUser`,
      userRights: `currentUserRights`,
    }),
    ...mapState(`model/notificationRule`, {
      storeUserNotificationRules: `currentUserNotificationRules`,
    }),
    userNotificationRules() {
      return _.filter(this.storeUserNotificationRules, { isNegative: false });
    },
    userNegativeNotificationRules() {
      return _.filter(this.storeUserNotificationRules, { isNegative: true });
    },
    title() {
      if (!this.user) { return ``; }

      let title = `${this.user.firstname || ``} ${this.user.lastname || ``}`;

      if (_.trim(title) === ``) {
        title = this.user.email || this.user.username;
      }

      return title;
    },
    isCurrentUserOnAggregator() {
      return this.client.slug && !this.client.isRoot;
    },
    isCurrentUserOnMaker() {
      return this.client.isRoot;
    },
    isCurrentUserOnSelfMaker() {
      return !this.client.isRoot && this.client.isSelfMaker;
    },
    tabs() {
      const tabs = [
        { key: 0, id: `infos`, label: `Infos générales` },
      ];
      if (this.isCurrentUserOnAggregator) {
        tabs.push({ key: _.last(tabs).key + 1, id: `rights`, label: `Droits d'accès` });
      }
      tabs.push({ key: _.last(tabs).key + 1, id: `notifications`, label: `Notifications` });
      if (
        (this.isSelfMaker && this.isCurrentUserOnSelfMaker)
        || (this.isMaker && this.isCurrentUserOnMaker)
      ) {
        tabs.push({ key: _.last(tabs).key + 1, id: `planning`, label: `Planning` });
      }

      return tabs;
    },
    $activeTab() {
      return this.tabs[this.activeTab];
    },
    infosTabKey() {
      const tab = _.find(this.tabs, { id: `infos` });
      if (tab) { return tab.key; }
      return null;
    },
    rightsTabKey() {
      const tab = _.find(this.tabs, { id: `rights` });
      if (tab) { return tab.key; }
      return null;
    },
    notificationsTabKey() {
      const tab = _.find(this.tabs, { id: `notifications` });
      if (tab) { return tab.key; }
      return null;
    },
    planningTabKey() {
      const tab = _.find(this.tabs, { id: `planning` });
      if (tab) { return tab.key; }
      return null;
    },
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
  },
  methods: {
    ...mapActions(`model/user`, [`setCurrentUser`]),
    async saveGlobalInformations() {
      this.isSavingInformations = true;
      try {
        await this.$store.dispatch(`model/user/saveUser`, this.user);
        this.setCurrentUser(_.clone(this.user));
        this.$store.dispatch(`showSnackbar`, {
          color: `success`,
          message: `Informations enregistrées`,
        });
      } catch (e) {
        this.$store.dispatch(`showSnackbar`, {
          color: `error`,
          message: `Impossible de mettre à jour l'utilisateur`,
        });
      }
      this.isMainAdminFlagUpdated = false;
      this.isSavingInformations = false;
    },
    rightChanged(right) {
      _.remove(this.rightsToUpdate, rightToUpdate => rightToUpdate.maker.id === right.maker.id);
      this.rightsToUpdate.push(right);
    },
    // clientUserRightChanged(user) {
    //   user.clientAdmin = user.$right.id === 1;
    // },
    async saveRights() {
      if (!this.rightsToUpdate.length) { return; }
      this.isSavingRights = true;

      await this.$store.dispatch(`model/user/saveUserRights`, this.rightsToUpdate);
      this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Droits enregistrés`,
      });

      this.rightsToUpdate = [];
      this.isSavingRights = false;
    },
    initLocalState() {
      this.activeTab = 0;
      this.isSavingInformations = false;
      this.isSavingRights = false;
      this.isMainAdminFlagUpdated = false;
      this.userRightsOrigin = [];
      this.rightsToUpdate = [];
    },
    async fetchRights() {
      this.isRightsLoading = true;
      await this.$store.dispatch(`model/user/fetchCurrentUserRights`);
      this.userRightsOrigin = _.cloneDeep(this.userRights);
      this.isRightsLoading = false;
    },
    async fetchNotificationRules() {
      this.isNotificationRulesLoading = true;
      await this.$store.dispatch(`model/notificationRule/fetchCurrentUserNotificationRules`);
      this.isNotificationRulesLoading = false;
    },
    getNotificationRuleTypeLabels(type) {
      const labels = [];
      if (_.includes([1, 3, 5, 7, 9, 11, 13, 15], type)) {
        labels.push(`créée`);
      }
      if (_.includes([2, 3, 6, 7, 10, 11, 14, 15], type)) {
        labels.push(`commentée`);
      }
      if (_.includes([4, 5, 6, 12, 13, 14, 15], type)) {
        labels.push(`nouvelle PJ`);
      }
      if (_.includes([8, 9, 10, 11, 12, 13, 14, 15], type)) {
        labels.push(`clôturée`);
      }

      return _.upperFirst(labels.join(`, `));
    },
    getNotificationRuleOriginLabels(origin) {
      const labels = [];
      if (_.includes([1, 3], origin)) {
        labels.push(`interne`);
      }
      if (_.includes([2, 3], origin)) {
        labels.push(`externe`);
      }

      return _.upperFirst(labels.join(`/`));
    },
    openConfirmRemoveRule(rule) {
      this.notificationRuleToBeRemoved = rule;
      this.isNotificationRuleRemoveDialogOpened = true;
    },
    removeNotificationRule() {
      this.$store.dispatch(`model/notificationRule/removeNotificationRule`, this.notificationRuleToBeRemoved.id);
    },
    async resendInvitation() {
      await this.$store.dispatch(`model/user/resendInvitation`, this.user);
      this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Invitation renvoyée`,
      });
    },
    async savePlanning() {
      this.isSavingPlanning = true;
      await this.$store.dispatch(`model/user/saveCurrentUser`);
      this.isSavingPlanning = false;
      this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Informations enregistrées`,
      });
    },
    closeDialog() {
      this.isOpened = false;
      this.$emit(`close`);
    },
  },
  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.fetchRights();
        this.initLocalState();
        this.user = _.clone(this.storeUser);
      }
    },
    activeTab() {
      if (this.$activeTab.id === `notifications`) {
        this.fetchNotificationRules();
      }
    },
  },
  components: {
    NotificationRuleDialog,
    UserPasswordDialog,
  },
};
</script>

<style lang="scss">
  .right-select {
    max-width: 200px;
  }
  .right-select .v-select__selections input {
    width: 0px !important;
  }

  .notification-rule {
    .v-chip {
      margin-right: 4px;
    }
  }
</style>
